import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconSettings } from '@sorare/core/src/atoms/icons/system/iconSettings.ts';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsOnboarding,
} from '@sorare/core/src/lib/playerSearchView';

import { PlayerSearchHelp } from '#src/searchCommonPlayer/PlayerSearchHelp/index.tsx';
import { StatsManager } from '#src/searchCommonPlayer/StatsManager/index.tsx';
import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const Root = styled(Vertical)`
  flex-shrink: 0;
`;
export const ToggleStatsManager = () => {
  const [open, setOpen] = useState(false);
  const { up: tabletOrAbove } = useScreenSize('tablet');
  const { statsManager, sawOnboarding } = useManagePlayerSearchView();

  const onClick = useLoggedCallback(() => {
    setOpen(true);
    if (
      statsManager[PlayerSearchViewAttributes.ONBOARDING] ===
      StatsOnboarding.INIT
    ) {
      sawOnboarding(StatsOnboarding.INIT);
    }
  });
  const onClose = () => {
    if (
      statsManager[PlayerSearchViewAttributes.ONBOARDING] ===
      StatsOnboarding.ADVANCED_VIEW
    ) {
      sawOnboarding(StatsOnboarding.ADVANCED_VIEW);
    }
    setOpen(false);
  };

  return (
    <Root center>
      <PlayerSearchHelp
        placement={tabletOrAbove ? 'left' : 'top'}
        step={StatsOnboarding.INIT}
      >
        <Button
          size="small"
          startIcon={<FontAwesomeIcon icon={iconSettings} />}
          onClick={onClick}
          color="quaternary"
          blur
        >
          <FormattedMessage {...scoutingCenter.advancedView} />
        </Button>
      </PlayerSearchHelp>
      <StatsManager open={open} onClose={onClose} />
    </Root>
  );
};
